// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
// import VueAwesomeSwiper from 'vue-awesome-swiper'
import axios from 'axios'
import API from './config/apiConfig' // 引入API 配置文件
import regular from './config/regular.js' // 引入正则 配置文件
import VueAxios from 'vue-axios'
import Vuex from 'vuex'
import store from './store/index.js'
import ElementUI from 'element-ui'
import VCharts from 'v-charts'
import 'element-ui/lib/theme-chalk/index.css'
import VueClipboard from 'vue-clipboard2'
Vue.prototype.$axios = axios

// require('swiper/dist/css/swiper.css')
// Vue.use(VueAwesomeSwiper)
Vue.use(Vuex)
Vue.use(VueAxios, axios)
Vue.use(ElementUI)
Vue.use(VCharts)
Vue.use(VueClipboard)
Vue.config.productionTip = false
Vue.prototype.$message = ElementUI.Message

// 拦截request请求，配置请求参数
axios.interceptors.request.use(function (config) {
  store.commit('loading', true)
  if (!config.timeout) {
    config.timeout = 5000 // 设置请求超时时长
  }
  config.headers.mtk = localStorage.getItem('usermtk') // 设置请求用户token
  return config
}, function (error) {
  store.commit('loading', false)
  return Promise.reject(error)
})
axios.interceptors.response.use(function (response) {
  // 对响应数据做点什么
  if (!(response.data.resCode === 1)) {
    if (response.data && response.data.resMsg[0] && response.data.resMsg[0].msgCode === '10005') {
      window.location.href = API.base.login
    } else {
      store.commit('loading', false)
      ElementUI.Message({
        message: response.data.resMsg[0].msgText,
        type: 'error'
      })
      let err = response.data.resMsg[0].msgText
      return Promise.reject(err)
    }
  }
  store.commit('loading', false)
  return response
}, function (error) {
  // 对响应错误做点什么
  store.commit('loading', false)
  return Promise.reject(error)
})

// 定义Vue全局内容
Vue.prototype.$API = API // 配置全局使用的api接口
Vue.prototype.regular = regular // 配置全局使用的正则

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  data: { // 集中的事件处理器
    eventHub: new Vue()
  },
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js